import { render } from "./SuspendUserModalComponent.vue?vue&type=template&id=20e9a6b6"
import script from "./SuspendUserModalComponent.vue?vue&type=script&lang=js"
export * from "./SuspendUserModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__